// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName
import { Application } from '@hotwired/stimulus'
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers"
import RailsNestedForm from '@stimulus-components/rails-nested-form/dist/stimulus-rails-nested-form.umd.js'

const application = Application.start()
application.register('nested-form', RailsNestedForm)

application.registerActionOption('withConfirm', ({ element }) => {
  return confirm(element.dataset.confirm || 'Are you sure?');
});

const context = require.context(".", true, /\.js$/)

application.load(definitionsFromContext(context))
application.debug = true
